import React, { type FC, type JSX } from 'react';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { SortValues } from '@/app/common/memsearch/types.ts';
import { Icon } from '@/app/common/icons/Icon';
import { ListViewSortItemContainer } from './styled';

type ListViewSortItemProps = {
  label?: string | JSX.Element;
  isLoading: boolean;
  value: string;
  currentValue: string;
  optionsLength?: number;
  handleOnClick: (value: string) => void;
};

const ListViewSortItem: FC<ListViewSortItemProps> = (props): JSX.Element => {
  const { label, value, currentValue, optionsLength, handleOnClick, isLoading } = props;
  const { localization } = usePageWrapperData();
  const hasIcon =
    value === SortValues.PriceAsc ||
    value === SortValues.PriceDesc ||
    value === SortValues.CategoryAsc ||
    value === SortValues.CategoryDesc;
  const isSelected = (currentValue ?? 'recommended') === value;

  return (
    <ListViewSortItemContainer
      key={value}
      onClick={isLoading ? undefined : () => handleOnClick(value)}
      isSelected={isSelected}
      optionsLength={optionsLength}
      localization={localization}
      isLoading={isLoading}
    >
      {label}
      {hasIcon && (
        <Icon
          category="Arrows"
          name="icon-vertical-sort"
          size={27}
          footprint={16}
          color={isSelected && !isLoading ? 'iconPrimaryDefault' : 'iconPrimary'}
          alt=""
        />
      )}
    </ListViewSortItemContainer>
  );
};

export default ListViewSortItem;
